import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Divider,
  Alert,
  Stack,
  Icon,
  Button,
} from "@mui/material";
import MDAutocomplete from "components/MDAutocomplete";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import MDLink from "components/MDLink";

import {
  defaultPaymentValues,
  InitialValues,
} from "../../layouts/pages/tenants/schemas/initialValues";
import {
  BillingAndCompanySchema,
  ValidationSchema,
} from "../../layouts/pages/tenants/schemas/validationSchema";

import { useState, useEffect, useContext } from "react";

import {
  Visibility,
  VisibilityOff,
  Add,
  Remove,
  Discount,
  Delete,
  RefreshSharp,
} from "@mui/icons-material";

import { formatToPhoneNumber } from "layouts/pages/tenants/tenant-admin";

// import { getPlans } from "lib/Api/Plans";
// import { getCoupons } from "lib/Api/Coupons";
import { registerTenant } from "lib/TenantApi/RegisterTenant/intex.js";
// import { selectPlanApi } from "lib/TenantApi/RegisterTenant/intex.js";
// import { couponValidate } from "lib/TenantApi/RegisterTenant/intex.js";
// import { getUserPlans } from "lib/TenantApi/RegisterTenant/intex.js";

import { LoginFormContext } from "context/loginFormCtx";

// import { PLAN_DURATION_TYPE } from "utils/constants";

// import DraggableDialog from "components/draggagle-dialog";

// import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

const AddTenantForm = () => {
  // const stripe = useStripe();
  // const elements = useElements();
  // const [isPaymentInProgress, setIsPaymentInProgress] = useState(false);
  // const [paymentDialog, setPaymentDialog] = useState(false);
  // const [stripeToken, setStripeToken] = useState(null);

  const { setNotification } = useContext(LoginFormContext);
  const navigate = useNavigate();

  const [password, setPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState(true);

  // const [plansList, setPlansList] = useState([]);
  // const [plansLoading, setPlansLoading] = useState(false);
  // const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);

  // const [couponsList, setCouponsList] = useState([]);
  // const [couponsLoading, setCouponsLoading] = useState(false);
  // const [selectedCouponDetails, setSelectedCouponDetails] = useState(null);
  // const [isCouponApplied, setIsCouponApplied] = useState(false);

  // const [sameAddress, setSameAddress] = useState(false);
  // const [isRegistrationCompleted, setIsRegistrationCompleted] = useState(false);
  // const [registeredUserId, setRegisteredUserId] = useState(null);

  // const [error, setError] = useState(null);

  // const fetchPlans = async () => {
  //   try {
  //     setPlansLoading(true);
  //     const response = await getPlans({
  //       sortBy: [{ id: "name", value: "asc" }],
  //       filters: [
  //         { id: "plan_type", value: 1 },
  //         { id: "status", value: 1 }
  //       ],
  //     });

  //     if (response && response.status === 200) {
  //       // Transform API response to dropdown-friendly format
  //       const plansOptions = response.data.data.rows.map((plan) => ({
  //         ...plan,
  //         value: plan.id,
  //         label: plan.name,
  //         storage: plan.Items?.find(item => item.item_id === "2")?.quantity || 0,
  //         Items: plan.Items.map(items => ({
  //           ...items,
  //           PlanItems: items.planItems,
  //         }))
  //       }));
  //               setPlansList(plansOptions);
  //     }
  //   } catch (error) {
  //   } finally {
  //     setPlansLoading(false);
  //   }
  // };

  // const fetchCoupons = async () => {
  //   try {
  //     setCouponsLoading(true);
  //     const response = await getCoupons({
  //       sortBy: [{ id: "coupon_name", value: "asc" }],
  //       filters: [{ id: "status", value: 1 }],
  //     });

  //     if (response && response.status === 200) {
  //       const today = new Date().getDate();

  //       const availableCoupons = response.data.data.rows.filter((coupon) => {
  //         const fromDate = new Date(coupon.coupon_applicable_from).getDate();
  //         const toDate = new Date(coupon.coupon_applicable_to).getDate();
  //         return today >= fromDate && today <= toDate && coupon.status === 1;
  //       });

  //       const couponsOptions = availableCoupons
  //         .filter((coupon) => (coupon.coupon_applicable_for == "1" || coupon.coupon_applicable_for == "2"))
  //         .map((coupon) => ({
  //           value: coupon.id,
  //           label: coupon.coupon_name,
  //           discount: coupon.discount,
  //           coupon_type: coupon.coupon_type,
  //           discount_type: coupon.coupon_type === 1 ? 'Fixed' : 'Percentage',
  //         }));

  //       setCouponsList(couponsOptions);
  //     }
  //   } catch (error) {
  //   } finally {
  //     setCouponsLoading(false);
  //   }
  // };

  // Initialize data on component mount
  // useEffect(() => {
  //   fetchPlans(); // Load available plans
  //   fetchCoupons(); // Load available coupons
  // }, []);

  // const handleIncrementUsers = () => {
  //   const currentValue = formik.values.numberOfUsers;
  //   if (currentValue < 1000) {
  //     formik.setFieldValue("numberOfUsers", currentValue + 1);
  //   }
  // };

  // const handleDecrementUsers = () => {
  //   const currentValue = formik.values.numberOfUsers;
  //   if (currentValue > 1) {
  //     formik.setFieldValue("numberOfUsers", currentValue - 1);
  //   }
  // };

  // const validateCoupon = async (couponId, planId) => {
  //   try {
  //     // Prepare validation data for API call
  //     const validationData = {
  //       id: couponId,
  //       plan_id: planId,
  //       user_id: null, // Will be set after user registration
  //     };

  //     const response = await couponValidate(validationData);

  //     if (response && response.status === 200) {
  //       // Coupon is valid, return the response data
  //       return response.data.data || response.data;
  //     } else {
  //       // Coupon validation failed - show error notification
  //       setNotification({
  //         color: "error",
  //         icon: "cancel",
  //         title: "Invalid Coupon",
  //         content: response?.data?.message || "This coupon is not valid for the selected plan.",
  //         open: true,
  //       });
  //       return null;
  //     }
  //   } catch (error) {

  //     setNotification({
  //       color: "error",
  //       icon: "cancel",
  //       title: "Coupon Validation Error",
  //       content: error?.response?.data?.message || "Failed to validate coupon. Please try again.",
  //       open: true,
  //     });
  //     return null;
  //   }
  // };

  //  handle clear coupon
  // const handleClearCoupon = () => {
  //   formik.setFieldValue("selectedCoupon", "");
  //   setSelectedCouponDetails(null);
  //   setIsCouponApplied(false);
  // };

  //  calculate final amount
  // const calculateFinalAmount = () => {
  //   if (!selectedPlanDetails) return 0;

  //   const subtotal = (selectedPlanDetails.per_user_charges || 0) * formik.values.numberOfUsers;

  //   if (!selectedCouponDetails) return subtotal;

  //   const discount = selectedCouponDetails.discount_type === 'Fixed'
  //     ? selectedCouponDetails.discount
  //     : (subtotal * selectedCouponDetails.discount / 100);

  //   return Math.max(0, subtotal - discount);
  // };

  //  reset card details
  // const resetCardDetails = () => {
  //   setStripeToken(null);
  //   setError(null);
  //   setPaymentDialog(false);
  //   setIsPaymentInProgress(false);
  // };

  //  reset payment details
  // const resetPaymentDetails = () => {
  //   setStripeToken(null);
  //   setError(null);
  //   setPaymentDialog(false);
  //   setIsPaymentInProgress(false);

  //   setIsRegistrationCompleted(false);
  //   setRegisteredUserId(null);

  //   formik.setFieldValue("selectedPlan", null, false);
  //   formik.setFieldValue("numberOfUsers", "", false);

  //   formik.setFieldValue("selectedCoupon", "", false);

  //   formik.setFieldValue("billing_address_line_1", "", false);
  //   formik.setFieldValue("billing_address_line_2", "", false);
  //   formik.setFieldValue("billing_country", "", false);
  //   formik.setFieldValue("billing_city", "", false);
  //   formik.setFieldValue("billing_zip_code", "", false);
  //   formik.setFieldValue("company_address_line_1", "", false);
  //   formik.setFieldValue("company_address_line_2", "", false);
  //   formik.setFieldValue("company_country", "", false);
  //   formik.setFieldValue("company_city", "", false);
  //   formik.setFieldValue("company_zip_code", "", false);
  //   formik.setFieldValue("same_as_billing_address", false, false);

  //   setSelectedPlanDetails(null);
  //   setSelectedCouponDetails(null);
  //   setIsCouponApplied(false);
  //   setSameAddress(false);
  // };

  //  handle payment submit
  // const handlePaymentSubmit = async (data, resetForm) => {
  //   try {
  //     setIsPaymentInProgress(true);

  //     const selectPlanBody = {
  //       token: stripeToken.id,
  //       planData: plansList.find(plan => plan.id === selectedPlanDetails.id),
  //       user_license_number: formik.values.numberOfUsers,
  //       billing_address: {
  //         address_line_1: formik.values.billing_address_line_1,
  //         address_line_2: formik.values.billing_address_line_2,
  //         country: formik.values.billing_country,
  //         city: formik.values.billing_city,
  //         zip_code: formik.values.billing_zip_code,
  //       },
  //       company_address: {
  //         address_line_1: formik.values.company_address_line_1,
  //         address_line_2: formik.values.company_address_line_2,
  //         country: formik.values.company_country,
  //         city: formik.values.company_city,
  //         zip_code: formik.values.company_zip_code,
  //       },
  //       final_amount: calculateFinalAmount(),
  //       coupon_id: selectedCouponDetails?.value ?? null,
  //       discount_amount: (selectedPlanDetails.per_user_charges * formik.values.numberOfUsers) - (calculateFinalAmount()),
  //       total_amount: selectedPlanDetails.per_user_charges * formik.values.numberOfUsers,
  //       coupon_name: selectedCouponDetails?.label ?? null,
  //       stripe_id: selectedCouponDetails?.stripe_id ?? null,
  //     };

  //     const response = await selectPlanApi(data, selectPlanBody);

  //     if(response.status === 200){
  //       resetForm(); // Reset form on successful payment

  //       setNotification({
  //         color: "success",
  //         icon: "check",
  //         title: "Success",
  //         content: "Tenant Registration Payment Successful!",
  //         open: true,
  //       });
  //       navigate("/tenants");
  //     }
  //     else{
  //       resetCardDetails();
  //       setNotification({
  //         color: "error",
  //         icon: "cancel",
  //         title: "Payment Error",
  //         content: `${response?.data?.message} Check your Payment details.` || 'Payment failed. Please try again, Check your Payment details.',
  //         open: true,
  //       });
  //     }
  //   } catch (catchError) {

  //     resetCardDetails();

  //     setNotification({
  //       color: "error",
  //       icon: "cancel",
  //       title: "Payment Error",
  //       content: `${catchError?.data?.message} Check your Payment details.` || 'Payment failed. Please try again with a different card.',
  //       open: true,
  //     });
  //   } finally {
  //     setIsPaymentInProgress(false);
  //   }
  // };

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Commented out payment logic - registration only
      // if (isRegistrationCompleted && registeredUserId && stripeToken?.id) {
      //   handlePaymentSubmit(registeredUserId, resetForm);
      //   return;
      // }

      // if (!stripeToken?.id && !paymentDialog && selectedPlanDetails) {
      //   setPaymentDialog(true);
      //   setSubmitting(false);
      //   return;
      // }

      setSubmitting(true);

      // Prepare tenant data for submission
      const tenantData = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        password: values.password,
        company_name: values.companyName,
        subdomain: values.subDomain,
        phone: values.phoneNumber,
        state: values.state,
        city: values.city,
      };

      // Call the registerTenant API
      const response = await registerTenant(tenantData);

      // Handle successful response
      if (response && response.status === 200) {
        // Store registration completion status and user ID
        // setIsRegistrationCompleted(true);
        // setRegisteredUserId(response.data.data.user.id);

        // Commented out coupon validation logic
        // if (selectedCouponDetails && response.data.data.user.id) {
        //   const couponValidationData = {
        //     id: selectedCouponDetails.value,
        //     plan_id: selectedPlanDetails?.id,
        //     user_id: response.data.data.user.id,
        //   };

        //   try {
        //     const couponValidationResponse = await couponValidate(couponValidationData);
        //     if (couponValidationResponse && couponValidationResponse.status === 200) {
        //       // Update coupon with validated data from response
        //       const validatedCouponData = couponValidationResponse.data.data || couponValidationResponse.data;
        //       const updatedCoupon = {
        //         ...validatedCouponData,
        //         value: validatedCouponData.id || selectedCouponDetails.value,
        //         label: validatedCouponData.coupon_name || selectedCouponDetails.label,
        //         discount: validatedCouponData.discount || selectedCouponDetails.discount,
        //         coupon_type: validatedCouponData.coupon_type || selectedCouponDetails.coupon_type,
        //         discount_type: validatedCouponData.coupon_type === 1 ? 'Fixed' : 'Percentage',
        //       };
        //       setSelectedCouponDetails(updatedCoupon);
        //       formik.setFieldValue("selectedCoupon", updatedCoupon.value);
        //     } else {
        //       // Coupon validation failed after registration, remove it
        //       setSelectedCouponDetails(null);
        //       formik.setFieldValue("selectedCoupon", "");
        //       setNotification({
        //         color: "warning",
        //         icon: "warning",
        //         title: "Coupon Removed",
        //         content: "The selected coupon is not valid for this user/plan and has been removed.",
        //         open: true,
        //       });
        //     }
        //   } catch (error) {

        //     // Remove coupon if validation fails
        //     setSelectedCouponDetails(null);
        //     formik.setFieldValue("selectedCoupon", "");
        //   }
        // }

        // Commented out payment logic
        // if(stripeToken?.id){
        //   handlePaymentSubmit(response.data.data.user.id, resetForm);
        //   return;
        // }

        // Complete registration without payment
        setSubmitting(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: "Tenant Registration Successful!",
          open: true,
        });
        navigate("/tenants");
      } else {
        // Handle error response
        const errorMessage = response?.data?.message || "Registration failed. Please try again.";
        setSubmitting(false);

        setNotification({
          color: "error",
          icon: "cancel",
          title: "Registration Error",
          content: errorMessage,
          open: true,
        });
      }
    } catch (error) {
      setSubmitting(false);

      // Commented out payment reset
      // resetPaymentDetails();

      setNotification({
        color: "error",
        icon: "cancel",
        title: "Registration Error",
        content: error.message || "Something went wrong!",
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: ValidationSchema,
    onSubmit: onSubmit,
    // context: { selectedPlan: InitialValues.selectedPlan },
  });

  // Reset same address checkbox when billing address changes
  // useEffect(() => {
  //   setSameAddress(false);
  // }, [
  //   formik.values.billing_address_line_1,
  //   formik.values.billing_address_line_2,
  //   formik.values.billing_country,
  //   formik.values.billing_city,
  //   formik.values.billing_zip_code
  // ]);

  //  handle same address
  // const handleSameAddress = () => {
  //   if (sameAddress) {
  //     setSameAddress(false);
  //     formik.setFieldValue("same_as_billing_address", false);
  //     return;
  //   }

  //   formik.setFieldValue("company_address_line_1", formik.values.billing_address_line_1 || "");
  //   formik.setFieldValue("company_address_line_2", formik.values.billing_address_line_2 || "");
  //   formik.setFieldValue("company_country", formik.values.billing_country || "");
  //   formik.setFieldValue("company_city", formik.values.billing_city || "");
  //   formik.setFieldValue("company_zip_code", formik.values.billing_zip_code || "");
  //   formik.setFieldValue("same_as_billing_address", true);
  //   setSameAddress(true);
  // };

  //  generate stripe data
  // const generateStripeData = async () => {
  //   if (!stripe || !elements || !CardElement) {
  //     return;
  //   }

  //   const { error: stripeError, token: stripeToken } = await stripe.createToken(
  //     // @ts-ignore
  //     elements.getElement(CardElement)
  //   );

  //   if (stripeError) {
  //     setError(
  //       stripeError.message ??
  //         'There is some error with your card. Please re enter all the details.'
  //     );
  //     // resetCardDetails();
  //   } else {
  //     setStripeToken(stripeToken);
  //     setPaymentDialog(false);
  //   }
  // };

  //  render payment content
  // const renderPaymentContent = (
  //   <>
  //     <Typography variant="h6" sx={{ mb: '1rem' }}>
  //       Total amount to be paid ${calculateFinalAmount().toFixed(2)}
  //     </Typography>
  //     <CardElement
  //       options={{
  //         style: {
  //           base: {
  //             fontSize: '16px',
  //           },
  //           invalid: {
  //           },
  //         },
  //         hidePostalCode: true,
  //       }}
  //     />
  //     <MDButton
  //       color="primary"
  //       variant="contained"
  //       size="medium"
  //       sx={{ mt: '1rem' }}
  //       type="submit"
  //       disabled={!stripe || formik.isSubmitting || isPaymentInProgress}
  //       onClick={generateStripeData}
  //     >
  //       Add Card
  //     </MDButton>
  //     {error && (
  //       <Alert severity="error" sx={{ mt: 3 }}>
  //         {error}
  //       </Alert>
  //     )}
  //   </>
  // );

  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate>
        <Box sx={{ px: 3 }}>
          <Grid container spacing={3}>
            {/* First Name & Last Name */}
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.firstName}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                name="firstName"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="First Name"
                helperText={formik.touched.firstName && formik.errors.firstName}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.lastName}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                name="lastName"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Last Name"
                helperText={formik.touched.lastName && formik.errors.lastName}
                fullWidth
                required
              />
            </Grid>

            {/* Company Name & Sub Domain */}
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.companyName}
                error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                name="companyName"
                onChange={(e) => {
                  formik.handleChange(e);
                  // Update subdomain based on company name
                  const companyName = e.target.value;
                  const subDomain = companyName
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, "")
                    .substring(0, 30);
                  formik.setFieldValue("subDomain", subDomain);
                }}
                onBlur={formik.handleBlur}
                label="Company Name"
                helperText={formik.touched.companyName && formik.errors.companyName}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.subDomain}
                error={formik.touched.subDomain && Boolean(formik.errors.subDomain)}
                name="subDomain"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Sub Domain"
                helperText={formik.touched.subDomain && formik.errors.subDomain}
                fullWidth
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography color="text.secondary" sx={{ fontSize: "16px" }}>
                        .mycasepath.app
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Email & Phone */}
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.email}
                error={formik.touched.email && Boolean(formik.errors.email)}
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Email Address"
                helperText={formik.touched.email && formik.errors.email}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={
                  formik.values.phoneNumber ? formatToPhoneNumber(formik.values.phoneNumber) : ""
                }
                error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                name="phoneNumber"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Phone Number"
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                fullWidth
                required
              />
            </Grid>

            {/* City & State */}
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.city}
                error={formik.touched.city && Boolean(formik.errors.city)}
                name="city"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="City"
                helperText={formik.touched.city && formik.errors.city}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={formik.values.state}
                error={formik.touched.state && Boolean(formik.errors.state)}
                name="state"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="State"
                helperText={formik.touched.state && formik.errors.state}
                fullWidth
                required
              />
            </Grid>

            {/* Password & Confirm Password */}
            <Grid item xs={12} md={6}>
              <TextField
                type={!password ? "text" : "password"}
                value={formik.values.password}
                error={formik.touched.password && Boolean(formik.errors.password)}
                name="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Password"
                helperText={formik.touched.password && formik.errors.password}
                fullWidth
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setPassword(!password)} edge="end" size="small">
                        {password ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                type={!confirmPassword ? "text" : "password"}
                value={formik.values.confirm_password}
                error={formik.touched.confirm_password && Boolean(formik.errors.confirm_password)}
                name="confirm_password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Confirm Password"
                helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                fullWidth
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setConfirmPassword(!confirmPassword)}
                        edge="end"
                        size="small"
                      >
                        {confirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />

          {/* Action Buttons */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
            <Button  variant="contained" type="submit" disabled={formik.isSubmitting}>
              Register Tenant
            </Button>
            <MDLink to="/tenants">
              <MDButton color="primary" variant="outlined" size="medium">
                Cancel
              </MDButton>
            </MDLink>
          </Box>

          {/* { !isCouponApplied && ( 
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer' }} onClick={() => {
                        setIsCouponApplied(!isCouponApplied);
                        setTimeout(() => {
                          const couponInput = document.querySelector('[data-testid="coupon-autocomplete-input"]');
                          if (couponInput) {
                            couponInput.focus();
                            couponInput.click();
                          }
                        }, 100);
                      }}>
                        <Discount 
                          sx={{ 
                            color: 'primary.main', 
                            mr: 0.5,
                            fontSize: '20px'
                          }} 
                        />
                        <Typography
                          variant="subtitle2"
                          color="primary"
                          sx={{ cursor: 'pointer' }}

                        >
                          Apply Coupon
                        </Typography>
                      </Box>
                      )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end',width: '100%' }}>

                    
                      { isCouponApplied && !selectedCouponDetails?.label && (
                       
    <Grid item xs={4} sm={4} md={4} sx={{ display: 'flex', justifyContent: 'flex-end',width: '100%' }}>
                    <MDAutocomplete
                            options={couponsList}
                            sx={{ width: '100%' }}
                            getOptionLabel={(option) => `${option.label} - ${option.discount_type === 'Fixed' ? '$' : ''}${option.discount}${option.discount_type === 'Percentage' ? '%' : ''}`}
                            loading={couponsLoading}
                            autoFocus={isCouponApplied && !selectedCouponDetails?.label}
                            onChange={async (event, newValue) => {
                              if (newValue && selectedPlanDetails) {
                                // const validatedCouponData = await validateCoupon(newValue.value, selectedPlanDetails.id); // Commented out
                                // if (validatedCouponData) { // Commented out
                                //   const validatedCoupon = { // Commented out
                                //     ...validatedCouponData, // Commented out
                                //     value: validatedCouponData.id || newValue.value, // Commented out
                                //     label: validatedCouponData.coupon_name || newValue.label, // Commented out
                                //     discount: validatedCouponData.discount || newValue.discount, // Commented out
                                //     coupon_type: validatedCouponData.coupon_type || newValue.coupon_type, // Commented out
                                //     discount_type: validatedCouponData.coupon_type === 1 ? 'Fixed' : 'Percentage', // Commented out
                                //   }; // Commented out
                                //   setSelectedCouponDetails(validatedCoupon); // Commented out
                                //   formik.setFieldValue("selectedCoupon", validatedCoupon.value); // Commented out
                                // } else { // Commented out
                                //   setSelectedCouponDetails(null); // Commented out
                                //   formik.setFieldValue("selectedCoupon", ""); // Commented out
                                // } // Commented out
                              } else if (newValue) {
                                setNotification({
                                  color: "error",
                                  icon: "cancel",
                                  title: "Plan Required",
                                  content: "Please select a plan first before applying a coupon.",
                                  open: true,
                                });
                                setSelectedCouponDetails(null);
                                formik.setFieldValue("selectedCoupon", "");
                              } else {
                                setSelectedCouponDetails(null);
                                formik.setFieldValue("selectedCoupon", "");
                              }
                            }}
                            onBlur={() => {
                              if (!selectedCouponDetails?.label) {
                                setIsCouponApplied(false);
                              }
                            }}
                            value={couponsList.find(coupon => coupon.value === formik.values.selectedCoupon) || null}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Coupon (Optional)"
                                placeholder="Search for available coupons..."
                                variant="outlined"
                                fullWidth
                                error={formik.touched.selectedCoupon && Boolean(formik.errors.selectedCoupon)}
                                helperText={formik.touched.selectedCoupon && formik.errors.selectedCoupon}
                                inputProps={{
                                  ...params.inputProps,
                                  'data-testid': 'coupon-autocomplete-input'
                                }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <Box component="li" {...props}>
                                <Box>
                                  <Typography variant="body2" color="text.primary">{option.label}</Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {option.discount_type === 'Fixed' ? '$' : ''}{option.discount}{option.discount_type === 'Percentage' ? '%' : ''} discount
                                  </Typography>
                                </Box>
                              </Box>
                            )}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                          />
                          </Grid>
                      )
                    }
                    </Box> 
                    {stripeToken && (
            <Stack
              spacing={1}
              component={Box}
              variant="outlined"
              sx={{
                p: 2.5,
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                mt: 2,
                borderRadius: 2,
                bgcolor: 'background.paper',
              }}
            >

              <Stack direction="row" alignItems="center" spacing={1}> 
                
                <Typography variant="subtitle2" sx={{fontWeight: '500' }}>
                Card Details
                </Typography>
                <Box sx={{ 
                  height: 24, 
                  borderRadius: 1,
                  px: 1,
                  border: '1px solid',
                  borderColor: 'text.primary',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
               }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: 'text.primary', 
                      fontWeight: 'bold',
                      textAlign: 'center',

                      fontSize: '0.7rem'
                    }}
                  >
                    {stripeToken.card?.brand.toUpperCase()}
                  </Typography>
                </Box>
                </Stack>
               

              <Typography variant="subtitle2" sx={{ fontFamily: 'monospace', fontWeight: '500' }}>
                **** **** **** {stripeToken.card?.last4}
              </Typography>

             
            </Stack>
          )}
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      mt: 2,
                      pt: 2,
                      borderTop: '1px dashed #e0e0e0'
                    }}>
                      <Typography variant="subtitle1" color="primary.main" sx={{ fontWeight: 'medium' }}>
                        Final Amount
                      </Typography>
                      <Typography variant="h6" color="primary.main" sx={{ fontWeight: 'bold' }}>
                        ${calculateFinalAmount().toFixed(2)}
                      </Typography>
                    </Box>
                  </Box>
              </Grid>
          </Grid>
          </Grid>
                )}
                
              </Grid>
        
        
        </Box>  */}
        </Box>

        {/* Card Details Display Section - Shows after payment dialog is closed */}

        {/* <DraggableDialog
        dialogTitle="Card Details"
        open={paymentDialog}
        onClose={() => {
          setPaymentDialog(false);
          setError(null);
          // Reset only card details when dialog is closed manually
          // resetCardDetails(); // Commented out
        }}
        dialogContent={
          <>
            {/* renderPaymentContent */}
        {/* </>
        }
      /> */}
      </form>
    </>
  );
};

export default AddTenantForm;
